module.exports = __webpack_public_path__ + "assets/page1Slogan.a6ebc794.png";